import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {GRAY_DARKER, GRAY_LIGHT} from 'ui-library/Colors';
import {Header2} from 'ui-library/Headers';

import WarehouseDiagramSQLEditor from './WarehouseDiagramSQLEditor';

interface WarehouseDiagramSidebarProps {
  modalSQLQuery: string;
  onModalSQLQueryChange: (newQuery: string) => void;
  sidebarWidth: number;
}

export default function WarehouseDiagramSidebar(props: WarehouseDiagramSidebarProps): JSX.Element {
  return (
    <div className={css(styles.sidebar)}>
      <div className={css(styles.sqlEditorHeader)}>
        <Header2>SQL query</Header2>
        <p className={css(styles.sidebarSubtext)}>
          Use this area to work on your SQL query. It will appear in the SQL editor when you close this
          window.
        </p>
      </div>
      <div className={classNames('scrollbar-override', css(styles.sqlEditorWrapper))}>
        <WarehouseDiagramSQLEditor
          modalSQLQuery={props.modalSQLQuery}
          onModalSQLQueryChange={props.onModalSQLQueryChange}
          sidebarWidth={props.sidebarWidth}
        />
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  sidebar: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  sqlEditorHeader: {
    padding: '0px 6px',
    borderBottom: `1px solid ${GRAY_LIGHT}`,
  },
  sidebarSubtext: {
    color: GRAY_DARKER,
  },
  sqlEditorWrapper: {
    flexGrow: 1,
  },
});
